import React from 'react'
import { Formik, Form, Field } from 'formik'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown'
import { Checkbox } from 'primereact/checkbox'
import CustomButton from '../../../shared/CustomButton'
import { t } from 'i18next'

const wards = [
  'General Ward A',
  'General Ward B',
  'ICU',
  'Emergency Ward',
  'Maternity Ward',
  'Pediatric Ward',
  'Surgical Ward',
  'Cardiac Ward'
]
const departments = [
  'General Medicine',
  'Emergency',
  'Surgery',
  'Cardiology',
  'Pediatrics',
  'Obstetrics & Gynecology',
  'Orthopedics',
  'Neurology'
]
const stages = [
  { label: 'Waiting Room', value: 'Waiting Room' },
  { label: 'In Consultation', value: 'In Consultation' },
  { label: 'Admitted', value: 'Admitted' },
  { label: 'Discharged', value: 'Discharged' }
]
const priorities = [
  { label: 'High', value: 'High' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Low', value: 'Low' }
]
const sexOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' }
]

const initialForm = {
  date: '',
  ward: '',
  department: '',
  patientFileNo: '',
  patientDOB: '',
  patientMobile: '',
  patientSex: '',
  reason: '',
  stage: '',
  priority: '',
  elective: false,
  mobilityAssistance: false,
  fallRisk: false,
  covid19: false,
  confused: false,
  visualSupervision: false,
  endOfLifePathway: false,
  insured: false,
  email: '',
  address: '',
  insuranceProvider: '',
  allergies: ''
}

const TimelineTab = ({ patient }) => {
  // Dummy timeline data
  const timelineData = [
    {
      id: 1,
      title: 'Patient Admitted',
      description: 'Patient admitted to General Ward A for observation',
      timestamp: '2 hours ago',
      type: 'admission',
      color: 'bg-green-500'
    },
    {
      id: 2,
      title: 'Blood Test Ordered',
      description: 'Complete blood count and liver function tests requested',
      timestamp: '4 hours ago',
      type: 'test',
      color: 'bg-yellow-500'
    },
    {
      id: 3,
      title: 'Consultation Completed',
      description: 'Initial consultation with Dr. Smith completed',
      timestamp: '6 hours ago',
      type: 'consultation',
      color: 'bg-purple-500'
    },
    {
      id: 4,
      title: 'Patient Registered',
      description: 'Patient checked in at reception desk',
      timestamp: '8 hours ago',
      type: 'registration',
      color: 'bg-gray-500'
    },
    {
      id: 5,
      title: 'Emergency Call',
      description: 'Patient brought in via ambulance',
      timestamp: '8 hours ago',
      type: 'emergency',
      color: 'bg-red-500'
    },
    {
      id: 6,
      title: 'Insurance Information Updated',
      description: "Patient's insurance details verified and updated",
      timestamp: '1 hour ago',
      type: 'insurance',
      color: 'bg-yellow-500'
    },
    {
      id: 7,
      title: 'Insurance Information Updated',
      description: "Patient's insurance details verified and updated",
      timestamp: '1 hour ago',
      type: 'insurance',
      color: 'bg-yellow-500'
    },
    {
      id: 8,
      title: 'Insurance Information Updated',
      description: "Patient's insurance details verified and updated",
      timestamp: '1 hour ago',
      type: 'insurance',
      color: 'bg-yellow-500'
    }
  ]

  const handleSubmit = (values, { resetForm }) => {
    // Save logic here
    alert('Timeline form saved (dummy action)')
    // resetForm();
  }

  return (
    <div className='h-full flex flex-col'>
      <div className='p-6 pb-4 flex-shrink-0'>
        <h2 className='text-2xl font-bold'>{t('Patient Timeline')}</h2>
      </div>
      <div className='flex-1 px-6 pb-6 overflow-y-auto'>
        <div className='grid grid-cols-1 gap-8 h-[calc(100vh-200px)]'>
          {/* Left Side - Form */}
          {/* <div className="bg-gray-50 rounded-lg flex flex-col">
            <div className="p-4 pb-3 flex-shrink-0 border-b border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800">
                Patient Information Form
              </h3>
            </div>
            <div className="overflow-y-auto p-4 h-[calc(100vh-250px)]">
              <Formik
                initialValues={{
                  ...initialForm,
                  patientFileNo: patient?.fileNo || "",
                }}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, setFieldValue, resetForm }) => (
                  <Form className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Date
                        </label>
                        <Field name="date">
                          {({ field }) => (
                            <InputText
                              {...field}
                              type="date"
                              className="w-full"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Ward
                        </label>
                        <Dropdown
                          name="ward"
                          value={values.ward}
                          options={wards.map((w) => ({ label: w, value: w }))}
                          onChange={(e) => setFieldValue("ward", e.value)}
                          placeholder="Select Ward"
                          className="w-full"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Department
                        </label>
                        <Dropdown
                          name="department"
                          value={values.department}
                          options={departments.map((d) => ({
                            label: d,
                            value: d,
                          }))}
                          onChange={(e) => setFieldValue("department", e.value)}
                          placeholder="Select Department"
                          className="w-full"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Patient File No.
                        </label>
                        <Field name="patientFileNo">
                          {({ field }) => (
                            <InputText
                              {...field}
                              className="w-full"
                              placeholder="Enter MRN"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Patient Date of Birth
                        </label>
                        <Field name="patientDOB">
                          {({ field }) => (
                            <InputText
                              {...field}
                              type="date"
                              className="w-full"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Patient Mobile No.
                        </label>
                        <Field name="patientMobile">
                          {({ field }) => (
                            <InputText
                              {...field}
                              className="w-full"
                              placeholder="Enter mobile number"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Patient Sex
                        </label>
                        <Dropdown
                          name="patientSex"
                          value={values.patientSex}
                          options={sexOptions}
                          onChange={(e) => setFieldValue("patientSex", e.value)}
                          placeholder="Select Sex"
                          className="w-full"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Reason
                        </label>
                        <Field name="reason">
                          {({ field }) => (
                            <InputTextarea
                              {...field}
                              rows={3}
                              className="w-full"
                              placeholder="Enter reason for visit"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Stage
                        </label>
                        <Dropdown
                          name="stage"
                          value={values.stage}
                          options={stages}
                          onChange={(e) => setFieldValue("stage", e.value)}
                          placeholder="Select Stage"
                          className="w-full"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Priority
                        </label>
                        <Dropdown
                          name="priority"
                          value={values.priority}
                          options={priorities}
                          onChange={(e) => setFieldValue("priority", e.value)}
                          placeholder="Select Priority"
                          className="w-full"
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {Object.entries({
                        elective: "Elective",
                        mobilityAssistance: "Mobility Assistance",
                        fallRisk: "Fall Risk",
                        covid19: "Covid 19",
                        confused: "Confused",
                        visualSupervision: "Visual Supervision",
                        endOfLifePathway: "End of Life Pathway",
                        insured: "Insured",
                      }).map(([name, label]) => (
                        <div key={name} className="flex items-center">
                          <Checkbox
                            inputId={name}
                            name={name}
                            checked={values[name]}
                            onChange={(e) => setFieldValue(name, e.checked)}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                          />
                          <label
                            htmlFor={name}
                            className="ml-2 text-sm text-gray-700"
                          >
                            {label}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Email
                        </label>
                        <Field name="email">
                          {({ field }) => (
                            <InputText
                              {...field}
                              type="email"
                              className="w-full"
                              placeholder="Enter email address"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Address
                        </label>
                        <Field name="address">
                          {({ field }) => (
                            <InputText
                              {...field}
                              className="w-full"
                              placeholder="Enter address"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Insurance Provider
                        </label>
                        <Field name="insuranceProvider">
                          {({ field }) => (
                            <InputText
                              {...field}
                              className="w-full"
                              placeholder="Enter insurance provider"
                            />
                          )}
                        </Field>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Allergies
                        </label>
                        <Field name="allergies">
                          {({ field }) => (
                            <InputText
                              {...field}
                              className="w-full"
                              placeholder="Enter known allergies"
                            />
                          )}
                        </Field>
                      </div>
                    </div>
                    <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
                      <CustomButton
                        type="button"
                        label="Reset"
                        className="p-button-secondary"
                        onClick={() => resetForm()}
                      />
                      <CustomButton
                        type="submit"
                        label="Save"
                        className="p-button-primary"
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>*/}
          {/* Right Side - Timeline */}
          <div className='bg-white rounded-lg flex flex-col border border-gray-200'>
            <div className='p-4 pb-3 flex-shrink-0 border-b border-gray-200'>
              <h3 className='text-lg font-semibold text-gray-800'>
               {t('Patient Timeline')}
              </h3>
            </div>
            <div className='overflow-y-auto p-4 h-[calc(100vh-250px)]'>
              <div className='relative'>
                {/* Vertical line */}
                <div className='absolute left-4 top-0 bottom-0 w-0.5 bg-gray-300'></div>
                {/* Timeline items */}
                <div className='space-y-6'>
                  {timelineData.map((item, index) => (
                    <div key={item.id} className='relative flex items-start'>
                      {/* Timeline dot */}
                      <div
                        className={`w-8 h-8 ${item.color} rounded-full flex items-center justify-center relative z-10 flex-shrink-0`}
                      >
                        <div className='w-3 h-3 bg-white rounded-full'></div>
                      </div>
                      {/* Timeline content */}
                      <div className='ml-4 flex-1'>
                        <div className='bg-gray-50 p-4 rounded-lg shadow-sm'>
                          <div className='flex items-center justify-between mb-2'>
                            <h4 className='font-semibold text-gray-800'>
                              {item.title}
                            </h4>
                            <span className='text-xs text-gray-500 bg-gray-200 px-2 py-1 rounded-full'>
                              {item.timestamp}
                            </span>
                          </div>
                          <p className='text-sm text-gray-600'>
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TimelineTab
